/* eslint-disable no-unused-vars */
/**
 * @typedef {Object} TimesheetAddedModelType
 * @property {ShortTermSubmitStatus} operationType - How the timesheet was submitted: accept|modify|cancel
 * @property {ShortTermStatus} previousStatus - Previous booking status
 * @property {ShortTermStatus} resultingStatus - New status after timesheet submit
 * @property {string} previousStartTime
 * @property {string} previousEndTime
 * @property {string} startTime
 * @property {string} endTime
 * @property {number} previousUnpaidBreakMinutes
 * @property {number} unpaidBreakMinutes
 * @property {number} differenceInDurationMinutes
 * @property {number} differenceInUnpaidBreakMinutes
 * @property {boolean} haveStartOrEndTimesChanged
 * @property {boolean} haveUnpaidBreakMinutesChanged
 * @property {boolean} haveBookingTimesBeenModified
 * @property {number} differenceBetweenStartTimesInMinutes
 */

import { ShortTermSubmitStatus } from '@/constants/booking/ShortTermSubmitStatus'
import { ShortTermStatus } from '@/constants/booking/ShortTermStatus'

/**
 * @class
 */
export default class TimesheetAddedModel {
  /**
   * Create a new TimesheetAddedModel.
   * @param {TimesheetAddedModelType} params
   */
  constructor(params) {
    this.operationType = params.operationType
    this.previousStatus = params.previousStatus
    this.resultingStatus = params.resultingStatus
    this.previousStartTime = params.previousStartTime
    this.previousEndTime = params.previousEndTime
    this.startTime = params.startTime
    this.endTime = params.endTime
    this.previousUnpaidBreakMinutes = params.previousUnpaidBreakMinutes
    this.unpaidBreakMinutes = params.unpaidBreakMinutes
    this.differenceInDurationMinutes = params.differenceInDurationMinutes
    this.differenceInUnpaidBreakMinutes = params.differenceInUnpaidBreakMinutes
    this.haveStartOrEndTimesChanged = params.haveStartOrEndTimesChanged
    this.haveUnpaidBreakMinutesChanged = params.haveUnpaidBreakMinutesChanged
    this.haveBookingTimesBeenModified = params.haveBookingTimesBeenModified
    this.differenceBetweenStartTimesInMinutes =
      params.differenceBetweenStartTimesInMinutes
  }
}
